import AccountSummary from "./Home/Modules/AccountSummary"
import ConsultantContact from "./Home/Modules/ConsultantContact"
import InteractiveMap from "./Home/InteractiveMap"
import TrendModule from "./Home/Modules/TrendModule";
import RenewalsModule from "./Home/Modules/RenewalsModule";
import FilesModule from "./Home/Modules/FilesModule";
import HomeTemplate from "../components/HomeTemplate";
import SupplyIcon from "../components/SupplyIcon";
import { useCurrentUser } from '../hooks/useCurrentUser';

function Home() {
  const { customerType } = useCurrentUser();

  return (
    <HomeTemplate>
      <HomeTemplate.Module  title="ACCOUNT SUMMARY" height={350} colSpan={{ base: 2, md: 1 }}>
        <AccountSummary />
      </HomeTemplate.Module>
      <HomeTemplate.Module  title="CONSULTANT" height={350} colSpan={{ base: 2, md: 1 }} order={{ base: 1, md: 'inherit' }}>
        <ConsultantContact/>
      </HomeTemplate.Module>
      <HomeTemplate.Module  title="SITE MAP" colSpan={{ base: 2, md: 2 }} rowSpan={{ base: 3, md: 3 }} height={{ base: 400, md: 'auto' }} minHeight={350} order={{ base: 2, lg: 'inherit' }}>
        <InteractiveMap />
      </HomeTemplate.Module>
      <HomeTemplate.Module icon={<SupplyIcon utility={"Electricity"}/>} title="ELECTRICITY - MONITORED TREND" link="hh-dashboard" height={250} colSpan={{ base: 2, md: 1 }}>
        <TrendModule utility="Electricity" />
      </HomeTemplate.Module>
      <HomeTemplate.Module icon={<SupplyIcon utility={"Gas"}/>} title="GAS - MONITORED TREND" link="hh-dashboard" height={250} colSpan={{ base: 2, md: 1 }}>
        <TrendModule utility="Gas" />
      </HomeTemplate.Module>
      <HomeTemplate.Module  title="UPCOMING RENEWALS" height={250} colSpan={{ base: 2, md: 1 }}>
        <RenewalsModule />
      </HomeTemplate.Module>
      {customerType === 'EYEBRIGHT' &&
        <HomeTemplate.Module  title="RECENT FILES" height={250} colSpan={{ base: 2, md: 1 }}>
          <FilesModule />
        </HomeTemplate.Module>
      }
    </HomeTemplate>
)
}

export default Home
